(function () {
    'use strict';

    angular.module('customerVault')
        .constant('WURFL_ADMIN_MICROSERVICE_URL', 'https://wurfl-admin-api.scientiamobile.com')
        .constant('CHARGIFY_JS_URL', 'https://js.chargify.com/latest/chargify.js')
        .constant('CHARGIFY_PUBLIC_KEY', 'chjs_njyxgkym38z2vpshbx5svh8p')
        .constant('CHARGIFY_SERVER_HOST', 'https://scientiamobile.chargify.com');
})();
